<!--
 * @Author: LiuMeiYu
 * @Date: 2023-01-09 17:05:07
 * @LastEditors: LiuMeiYu
 * @LastEditTime: 2023-03-14 15:58:55
 * @FilePath: \nivara\src\components\popupView.vue
 * @Description: *
 * *
 * Copyright (c) 2023 by yihua, All Rights Reserved.
-->
<template>
  <div class="popup-container" v-if="isShow">
    <div class="popup-wrap">
      <div class="popup-header">
        {{ title }}
        <el-image
          class="close-popup"
          :src="require('../assets/images/close_popup.png')"
          alt="close-popup"
          @click="close"
        />
      </div>
      <div class="popup-content">
        <slot name="content"></slot>
      </div>
    </div>
  </div>
</template>
<script lang="ts">
import { defineComponent, ref } from "vue";

export default defineComponent({
  name: "Popup",
  props: {
    title: {
      type: String,
      default: "",
    },
  },
  emits: ["closePopup"],
  setup(props, { emit }) {
    let isShow = ref(false);
    const open = () => {
      isShow.value = true;
    };
    const close = () => {
      isShow.value = false;
      emit("closePopup");
    };
    return { isShow, open, close };
  },
});
</script>

<style lang="less" scoped>
.popup-container {
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(0, 0, 0, .4);
  z-index: 100;
  .popup-wrap {
    position: relative;
    width: 50%;
    max-height: 80%;
    overflow: auto;
    display: flex;
    flex-direction: column;
    background-color: #ffffff;
    border-radius: 12px;

    .popup-header {
      position: relative;
      min-height: 60px;
      display: flex;
      align-items: center;
      padding-left: 20px;
      overflow: hidden;
      font-weight: bold;
      color: #444444;
      border-bottom: 1px solid #D2D2D2;

      .close-popup {
        position: absolute;
        width: 15px;
        height: 15px;
        right: 20px;
        top: 20px;
        cursor: pointer;
      }
    }

    .popup-content {
      flex: 1;
      display: flex;
      flex-direction: column;
      overflow-y: auto;

      &::-webkit-scrollbar {
        width: 8px; /*滚动条宽度*/
        height: 10px; /*滚动条高度*/
      }
      &::-webkit-scrollbar-track {
        box-shadow: 0px 1px 3px #f8f8f8 inset; /*滚动条的背景区域的内阴影*/
        border-radius: 10px; /*滚动条的背景区域的圆角*/
        background-color: #f8f8f8; /*滚动条的背景颜色*/
      }
      &::-webkit-scrollbar-thumb {
        box-shadow: 0px 1px 3px #03034d inset; /*滚动条的内阴影*/
        border-radius: 10px; /*滚动条的圆角*/
        background-color: #03034d; /*滚动条的背景颜色*/
      }
    }
  }
}
</style>
